import * as ActionTypes from 'modules/lockers/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = {
  size: 10,
  number: 0,
  totalElements: 0,
};

const setState = (_, { payload }) => payload.page;

export default createReducer(initialState, {
  [ActionTypes.GET_LOCKERS_SUCCESS]: setState,
});
